var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.4766C16.2234 10.4766 18.0258 8.80288 18.0258 6.73828C18.0258 4.67369 16.2234 3 14 3C11.7766 3 9.97416 4.67369 9.97416 6.73828C9.97416 8.80288 11.7766 10.4766 14 10.4766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1442 10.4766C23.5498 10.4766 24.6893 9.41849 24.6893 8.11328C24.6893 6.80808 23.5498 5.75 22.1442 5.75C20.7386 5.75 19.5992 6.80808 19.5992 8.11328C19.5992 9.41849 20.7386 10.4766 22.1442 10.4766Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85577 10.4766C7.26137 10.4766 8.40084 9.41849 8.40084 8.11328C8.40084 6.80808 7.26137 5.75 5.85577 5.75C4.45017 5.75 3.3107 6.80808 3.3107 8.11328C3.3107 9.41849 4.45017 10.4766 5.85577 10.4766Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36336 12.5983C7.36153 11.8361 6.45423 11.937 5.29585 11.937C3.56335 11.937 2.15385 13.2381 2.15385 14.837V19.5296C2.15385 20.224 2.7642 20.7886 3.51477 20.7886C6.75515 20.7886 6.36478 20.843 6.36478 20.6588C6.36478 17.3337 5.94064 14.8951 8.36336 12.5983Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1017 11.955C13.0784 11.7983 11.3198 11.9568 9.80286 13.1195C7.2644 15.0075 7.75292 17.5497 7.75292 20.6596C7.75292 21.4824 8.47387 22.1644 9.37344 22.1644C19.1411 22.1644 19.5298 22.4569 20.109 21.2659C20.299 20.8631 20.2469 20.9911 20.2469 17.1379C20.2469 14.0774 17.3931 11.955 15.1017 11.955ZM22.7041 11.9378C21.5393 11.9378 20.637 11.838 19.6366 12.5991C22.0412 14.8788 21.6351 17.151 21.6351 20.6596C21.6351 20.845 21.3111 20.7894 24.4366 20.7894C25.214 20.7894 25.8461 20.2046 25.8461 19.4857V14.8378C25.8461 13.2389 24.4366 11.9378 22.7041 11.9378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserlist);
export default __webpack_public_path__ + "static/media/ic_userlist.f8ad23f4b870325a0f16b91423aa809d.svg";
export { ForwardRef as ReactComponent };